import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { BetriebstypDetailsDialogComponent } from './betriebstyp-details-dialog/betriebstyp-details-dialog.component';
import { Betriebstyp } from './betriebstyp';

@Component({
    selector: 'kiene-betriebstypen',
    templateUrl: './betriebstypen.component.html',
    styleUrls: ['./betriebstypen.component.scss'],
})
export class BetriebstypenComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        public dialog: MatDialog,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
        private api: KieneTableService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Betriebstypen';
        this.tableDescriptor.uniqueIdentifier = 'Betriebstypen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'betriebstyp/';
        this.tableDescriptor.route = '/stammdaten/betriebstypen/';
        this.tableDescriptor.nameOfIdField = 'betriebstyp_id';
        this.tableDescriptor.searchPlaceholder = 'Betriebstypen durchsuchen';
        this.tableDescriptor.columns.push(new TableColumn('betriebstyp_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('betriebstyp', 'Betriebstyp'));
        this.tableDescriptor.columns.push(new TableColumn('impfstoff_zusatz', 'Impfstoffzusatz'));
        this.tableDescriptor.columns.push(new TableColumn('antibiotika_zusatz', 'Antibiotikazusatz'));

        this.tableDescriptor.permissionView = 4471;
        this.tableDescriptor.permissionCreate = 4472;

        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.options.push(new TableOption(this.edit.bind(this), 'bearbeiten', 'edit', 4472));
        this.tableDescriptor.options.push(new TableOption(this.delete.bind(this), 'löschen', 'delete', 4474));

        this.tableDescriptor.initialSortColumn = 'betriebstyp';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.add.bind(this);
    }

    edit(betriebstyp: Betriebstyp) {
        const dialogRef = this.dialog.open(BetriebstypDetailsDialogComponent, { data: { betriebstyp: betriebstyp } });
        dialogRef.afterClosed().subscribe({
            next: () => {
                this.api.reload();
            },
        });
    }

    add() {
        const dialogRef = this.dialog.open(BetriebstypDetailsDialogComponent);
        dialogRef.afterClosed().subscribe({
            next: () => {
                this.api.reload();
            },
        });
    }

    delete(betriebstyp: Betriebstyp) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            data: { title: 'Betriebstyp löschen', text: 'Wollen Sie den Betriebstypen wirklich löschen?' },
        });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.api.deleteEntity(this.apiBaseUrl + 'betriebstyp/delete.php', betriebstyp).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Der Betriebstyp wurde erfolgreich gelöscht!');
                            this.api.reload();
                        },
                        error: err => {
                            this.messageService.errorMessage('Der Betriebstyp konnte nicht gelöscht werden!', err);
                        },
                    });
                }
            },
        });
    }
}
